/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fleetType: NonNullable<unknown> }} Client_Fleet_Type_LabelInputs */

const en_client_fleet_type_label = /** @type {(inputs: Client_Fleet_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.fleetType === "industrial_machinery_and_equipment") return /** @type {LocalizedString} */ (`Industrial machinery and equipment`);
	if (i?.fleetType === "buses") return /** @type {LocalizedString} */ (`Buses`);
	if (i?.fleetType === "utility_vehicles_and_vans") return /** @type {LocalizedString} */ (`Utility vehicles and vans`);
	if (i?.fleetType === "two_wheeled_vehicles") return /** @type {LocalizedString} */ (`Two-wheeled vehicles`);
	if (i?.fleetType === "light_vehicles") return /** @type {LocalizedString} */ (`Light vehicles`);
	if (i?.fleetType === "heavy_vehicles") return /** @type {LocalizedString} */ (`Heavy vehicles`);
	return /** @type {LocalizedString} */ (`${i?.fleetType}`)
	
};

const pt_br2_client_fleet_type_label = /** @type {(inputs: Client_Fleet_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.fleetType === "industrial_machinery_and_equipment") return /** @type {LocalizedString} */ (`Máquinas e equipamentos industriais`);
	if (i?.fleetType === "buses") return /** @type {LocalizedString} */ (`Ônibus`);
	if (i?.fleetType === "utility_vehicles_and_vans") return /** @type {LocalizedString} */ (`Utilitários e vans`);
	if (i?.fleetType === "two_wheeled_vehicles") return /** @type {LocalizedString} */ (`Veículos de duas rodas`);
	if (i?.fleetType === "light_vehicles") return /** @type {LocalizedString} */ (`Veículos leves`);
	if (i?.fleetType === "heavy_vehicles") return /** @type {LocalizedString} */ (`Veículos pesados`);
	return /** @type {LocalizedString} */ (`${i?.fleetType}`)
	
};

/**
* | fleetType | output |
* | --- | --- |
* | "industrial_machinery_and_equipment" | "Industrial machinery and equipment" |
* | "buses" | "Buses" |
* | "utility_vehicles_and_vans" | "Utility vehicles and vans" |
* | "two_wheeled_vehicles" | "Two-wheeled vehicles" |
* | "light_vehicles" | "Light vehicles" |
* | "heavy_vehicles" | "Heavy vehicles" |
* | * | "{fleetType}" |
*
* @param {Client_Fleet_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_fleet_type_label = /** @type {((inputs: Client_Fleet_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Fleet_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_fleet_type_label(inputs)
	return pt_br2_client_fleet_type_label(inputs)
});